import { __decorate } from "tslib";
import { sync } from '@genesislcap/foundation-utils';
import { css, html, observable, ref } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { setValueWithAccessor } from './utils';
/**
 * The AG Text Field Renderer element.
 * @public
 * @tagname %%prefix%%-grid-text-field-renderer

 */
export class AgTextFieldRenderer extends FoundationElement {
    constructor() {
        super(...arguments);
        // Text field value
        this.textValue = '';
        /**
         * On text change handler
         * @param e - CustomEvent
         */
        this.textChanged = (e) => {
            this.textValue = e.target.value;
            this.params.onChange(e.target.value, this.params);
        };
    }
    init(params) {
        var _a;
        if (!params)
            return;
        this.params = params;
        this.textValue =
            this.textValue === ''
                ? setValueWithAccessor((_a = params === null || params === void 0 ? void 0 : params.node) === null || _a === void 0 ? void 0 : _a.data, params.accessor)
                : this.textValue;
    }
    getGui() {
        return this;
    }
    destroy() { }
    refresh(params) {
        return true;
    }
}
__decorate([
    observable
], AgTextFieldRenderer.prototype, "textValue", void 0);
__decorate([
    observable
], AgTextFieldRenderer.prototype, "params", void 0);
/**
 * The AG Text Field Renderer Styles.
 * @public
 */
export const textFieldRendererStyles = css `
  :host {
    display: flex;
    width: 100%;
    height: 100%;
    align-center: center;
  }
  .text-renderer {
    width: 100%;
  }
`;
/**
 * Get a Design System prefixed Text Field template.
 * @param designSystem - The design system prefix to use. Defaults to 'foundation'.
 * @returns A Text Field component template prefixed with the correct design system.
 * @public
 */
export const getTextFieldRendererTemplate = (designSystem = 'foundation') => {
    const textComponent = `${designSystem}-text-field`;
    return html `
    <${textComponent}
      ${ref('textField')}
      type="text"
      class="text-renderer"
      :value="${sync((x) => x.textValue)}"
      @change="${(x, c) => x.textChanged(c.event)}"
    ></${textComponent}>
  `;
};
/**
 * A function that returns a Foundation Text Field Renderer registration for configuring the component with a DesignSystem.
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-grid-pro-text-field-renderer\>
 */
export const foundationAgTextFieldRenderer = AgTextFieldRenderer.compose({
    baseName: 'grid-pro-text-renderer',
    styles: textFieldRendererStyles,
    template: getTextFieldRendererTemplate(),
});
